import { render } from "./ScreenCreate.vue?vue&type=template&id=019ebe50"
import script from "./ScreenCreate.vue?vue&type=script&lang=js"
export * from "./ScreenCreate.vue?vue&type=script&lang=js"

import "./ScreenCreate.vue?vue&type=style&index=0&id=019ebe50&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__